import { versionColumns } from "@/mocks/homeData";
import SectionHeading from "./SectionHeading";

export default function VersionSection() {
  return (
    <section id="versions" className="w-full bg-background-50 px-4 py-14 md:px-8 md:py-20">
      <div className="mx-auto max-w-6xl">
        <SectionHeading
          eyebrow="版本下载"
          title="安卓版下载与苹果版下载，差异一次看清"
          description="两个版本的功能基本一致，区别主要在获取方式、系统要求和更新路径。对照下面的表格，就能快速确认自己该看哪一列。"
        />

        <div className="mt-9 grid grid-cols-1 gap-5 md:mt-12 lg:grid-cols-2">
          {versionColumns.map((column) => (
            <div
              key={column.id}
              className="overflow-hidden rounded-lg border border-background-200 bg-background-100"
            >
              <div className="flex items-center gap-4 border-b border-background-200 bg-background-50 p-5 md:p-6">
                <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-500">
                  <i className={`${column.icon} text-2xl text-background-50`}></i>
                </span>
                <div>
                  <h3 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">
                    {column.title}
                  </h3>
                  <p className="mt-0.5 text-xs font-medium text-foreground-500 md:text-sm">
                    {column.subtitle}
                  </p>
                </div>
              </div>
              <dl className="divide-y divide-background-200">
                {column.rows.map((row) => (
                  <div key={row.label} className="grid grid-cols-1 gap-1 p-4 sm:grid-cols-[110px_1fr] sm:gap-4 md:p-5">
                    <dt className="text-sm font-semibold text-foreground-500">{row.label}</dt>
                    <dd className="text-sm leading-relaxed text-foreground-800">{row.value}</dd>
                  </div>
                ))}
              </dl>
            </div>
          ))}
        </div>

        <div className="mt-6 flex items-start gap-3 rounded-lg border border-background-200 bg-secondary-50 p-5 md:mt-8 md:p-6">
          <span className="flex h-6 w-6 flex-shrink-0 items-center justify-center">
            <i className="ri-information-line text-xl text-secondary-600"></i>
          </span>
          <p className="text-sm leading-relaxed text-foreground-700">
            不同设备与系统版本的界面细节可能略有差别，上文给出的系统要求与权限说明用于参考，实际以你手机上的提示为准。若安装过程中遇到拦截或权限弹窗，先按系统提示处理，再回到对应步骤继续。
          </p>
        </div>
      </div>
    </section>
  );
}